// extracted by mini-css-extract-plugin
module.exports = {"button":"button-1aWzF","paper":"paper-2ycwG"};